import "./styles.scss";

export const WidgetsContainer = ({ children }) => {
  return (
    <div id="Widgets" className="Widgets">
      {children}
    </div>
  );
};
